import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloClient, ApolloProvider, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { cache } from './cache';
import { UserProvider } from './context/UserContext';
import * as Cookies from 'js-cookie';

//1. Create an http link
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_ENDPOINT,
  credentials: "include" // Enable to include cookies
})
//2. Create authLink
const authLink = setContext((_, { headers, ...rest }) => {
  const token = Cookies.get('api_key');
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`
    },
    ...rest
  }
})

const client = new ApolloClient({
  //3. Concatenate the auth and httplink for doing requests
  // link: authLink.concat(httpLink),
  link: httpLink,
  cache
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <UserProvider>

        <App />
      </UserProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
